import { TLocoType } from 'shared/hooks/use-loco-translation'
import { ProductOptionInterface } from '../types/product-option-interface'
import {
  ProductVariantInterface,
  ProductVariantsErrorsInterface,
} from '../types/product-variant-interface'

export const filterVariants = (variants: ProductVariantInterface[]) =>
  variants
    .filter(variant => !variant.deleted)
    .map(variant => {
      const filteredVariant = { ...variant }
      delete filteredVariant.deleted
      delete filteredVariant.selected
      delete filteredVariant.productOptionValues
      return filteredVariant
    })

export const filterOptions = (options: ProductOptionInterface[]) =>
  options.map(option => {
    const filteredOptionValues = option.optionValues.filter(optionValue => !!optionValue.value)
    return { ...option, optionValues: filteredOptionValues }
  })

export const validateVariants = (
  variants: ProductVariantInterface[],
  t: TLocoType,
  setError: (errors: ProductVariantsErrorsInterface) => void,
) => {
  //check sku field in variants
  const variantErrors = variants.reduce((acc, curr) => {
    if (!curr.sku) {
      return {
        ...acc,
        [curr.id]: { sku: t('dashboard.validation.empty_error.title') },
      }
    }
    return acc
  }, {})

  setError(variantErrors)

  return !(Object.keys(variantErrors).length > 0)
}
